import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { I18NService } from '@ithinkdt/shared/i18n';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { FormSearchService } from '../fetch/form-fetch.service';

const DEFAULT_PAGENUMBER = 1;

@Component({
  selector: 'dt-form-search-select',
  templateUrl: './form-search-select.component.html',
  styleUrls: ['./form-search-select.component.scss'],
})
export class FormSearchSelectComponent implements OnChanges, OnDestroy {
  // optionæ°æ®
  optionsList: object[] = [];
  // æ²¡ææ°æ®æ¾ç¤º
  noDataContent = this.i18nSrv.interpret('noData');
  isLoading = false;
  // è¯·æ±ä¸ææ°æ®çå¬
  private searchText$ = new Subject<any>();
  private pageSize = 10;
  private pageNumber: number = DEFAULT_PAGENUMBER;
  private inputVal = '';

  @Input() getListKey: string;
  @Input() labelKey: string;
  @Input() valueKey: string;
  @Input() requestApi: string;
  @Input() time = 500;
  @Input() nzMode = "'default'";
  @Input() ctrlName: string;
  @Input() form: string;
  @Input() nzShowSearch = true;

  constructor(private formSearchSrv: FormSearchService, private i18nSrv: I18NService) {}

  ngOnChanges(sc: SimpleChanges) {
    if (sc.getListKey.firstChange) {
      this.addSearchSub();
    }
  }

  ngOnDestroy() {
    this.searchText$.unsubscribe();
  }

  // æ·»å æç´¢optionçå¬ èæµ
  addSearchSub() {
    this.searchText$
      .pipe(
        debounceTime(this.time),
        distinctUntilChanged(),
        switchMap((param) => this.formSearchSrv.searchSelect(this.requestApi, param))
      )
      .subscribe((res: any) => {
        if (res.status) {
          this.optionsList = [...this.optionsList, ...res.data];
          this.isLoading = false;
          this.noDataContent = this.i18nSrv.interpret('nomatchingResult');
        }
      });
  }

  // ä¸ææ¡è¾å¥åè°,è§¦åé²ææºå¶
  onSearch(val?) {
    if (!val) {
      return;
    }
    this.isLoading = true;
    this.inputVal = val;
    this.resetTemp();
    this.searchData(val);
  }

  loadMore() {
    this.pageNumber++;
    this.searchData(this.inputVal);
  }

  searchData(val) {
    const param: any = {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
    };
    Object.defineProperty(param, this.getListKey, {
      value: val,
      enumerable: true,
    });

    this.searchText$.next(param);
  }

  openChange(open) {
    this.resetTemp();
  }

  resetTemp() {
    this.pageNumber = DEFAULT_PAGENUMBER;
    this.optionsList = [];
  }
}
